import {moment} from 'moment';
import {ISyncField} from "../../../index";
import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {convertFromServerString, convertToServerString} from "../../../util/datetime";
import {isNullOrUndefined} from "../../../util/misc";
import {INPUT_DATE_FORMAT} from "../../../constants";
import editHtml from './edit.html?raw';

export let template = editHtml;

interface IParams {
    syncfield: ISyncField
    value: KnockoutObservable<string>
    inputAttributes?: any
}

export class viewModel {
    private readonly syncfield: ISyncField;
    private readonly value: KnockoutObservable<string>;
    private readonly dateValue: KnockoutObservable<string | null> = ko.observable(null);
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly attr: any;

    constructor(params: IParams) {
        this.syncfield = params.syncfield;
        this.value = params.value;
        this.attr = params.inputAttributes
        if (this.isSyncFieldDate()) {
            if (!isNullOrUndefined(this.value())) {
                const dateValue = convertFromServerString(this.value());
                this.dateValue(dateValue.format(INPUT_DATE_FORMAT));
            } else {
                this.dateValue(null);
            }
        }
        this.kosub.subscribe(this.dateValue, (val: string | null) => {
            if (val === null) {
                this.value('');
                return;
            }
            this.value(convertToServerString(moment(val)) ?? '');
        });
    }

    private isSyncFieldDate(): boolean {
        return this.syncfield.fieldtype == 'DateTime';
    }

    private getDisplayValue(): string {
        if (this.isSyncFieldDate()) {
            const m = moment(this.dateValue());
            if (m.isValid()) {
                return m.format('L');
            } else {
                return 'choose subject|s:((date|ac))'
            }
        }
        return this.value();
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }

}
